<template>
  <b-modal size="sm" centered title="提示" v-model="remindShow" hide-footer hide-header @hide="liveCancel">
    <div class="modal-head"><span>温馨提示</span></div>
    <div class="modal-content">
      <div>1、直播默认开启摄像头，您可以在进入直播后，从右上角设置中关闭摄像头</div>
      <div>2、建议使用耳机，以获得更好的直播体验</div>
    </div>
    <div class="modal-bottom">
      <div class="modal-cancel" @click="liveCancel">取 消</div>
      <div class="modal-determine" @click="testing">进入直播</div>
    </div>
    <div class="modal-tips" @click="noTips">
      <img :src="tip==2 ? require('../../../images/tips-true.png') : require('../../../images/tips-false.png')" />
      不再提醒
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    isShow: {
      //
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tip: false // 是否不再提醒,
    }
  },
  computed: {
    remindShow: {
      get () {
        return this.isShow
      },
      set (val) {
        console.log(val)
        this.$emit('changeShow', val)
      }
    }
  },
  watch: {
    isShow: {
      // 深度监听，可监听到对象、数组的变化
      handler (newV, oldV) {
        this.remindShow = newV
      },
      deep: true
    }
  },
  created () {
    this.tip = 1
    console.log(localStorage.getItem('livtips'))
  },
  methods: {
    testing () { // 设备检测
      // var promise = navigator.mediaDevices.getUserMedia('audio')
      if (navigator.mediaDevices.getUserMedia) {
        const constraints = { audio: true }
        navigator.mediaDevices.getUserMedia(constraints).then(
          stream => {
            console.log('授权成功！')
            this.liveDetermine()
          },
          (error) => {
            console.log(error + '')
            let data = error + ''
            console.log(data.split(': ')[1])
            if (data.split(': ')[1] == 'Permission denied') {
              this.$bvToast.toast('请前往浏览器设置中心开启麦克风权限!', {
                title: '提示',
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                solid: true
              })
            } else if (data.split(': ')[1] == 'Msndatory unsatisfied error') {
              this.$bvToast.toast('该设备未发现语音通话设备,请检查!', {
                title: '提示',
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                solid: true
              })
            } else if (data.split(': ')[1] == 'Not supported error') {
              this.$bvToast.toast('该浏览器暂不支持语音通话,请下载最新谷歌浏览器!', {
                title: '提示',
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                solid: true
              })
            } else if (data.split(': ')[1] == 'Requested device not found') {
              this.$bvToast.toast('该设备未发现语音通话设备,请检查!', {
                title: '提示',
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                solid: true
              })
            }

            // PERMISSION_DENIED：用户拒绝提供信息。
            // NOT_SUPPORTED_ERROR：浏览器不支持硬件设备。
            // MANDATORY_UNSATISFIED_ERROR：无法发现指定的硬件设备。
            //   window.location.href = 'chrome://settings/content'
          }
        )
      } else {
        console.error('浏览器不支持 getUserMedia')
      }
    },
    liveCancel () {
      // 取消
      this.remindShow = false
      this.$emit('close', this.remindShow)
    },
    liveDetermine () {
      // 进入直播
      this.$emit('determine', null)
    },
    noTips () {
      // 不再提醒
      this.tip = this.tip == 1 ? 2 : 1
      localStorage.setItem('livtips', this.tip)
      console.log(localStorage.getItem('livtips'))
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-tips {
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  color: #999999;
  cursor: pointer;
  img {
    width: 15px;
    height: 15px;
    margin-right: 0.3125rem;
    margin-bottom: -0.125rem;
  }
}
.modal-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.675rem;
  margin-top: 0.9375rem;
  .modal-cancel {
    display: block;
    background-color: rgb(229, 227, 226);
    padding: 10px;
    text-align: center;
    border-radius: 0.3125rem;
    color: #666666;
    text-indent: 0px;
    margin-right: 2.5rem;
    cursor: pointer;
    flex: 3;
  }
  .modal-determine {
    display: block;
    background-color: rgb(246, 210, 70);
    padding: 10px;
    text-align: center;
    border-radius: 0.3125rem;
    text-indent: 0px;
    color: white;
    cursor: pointer;
    flex: 3;
  }
}
.modal-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin-bottom: 1.25rem;
  span {
    text-align: center;
    &:nth-child(1) {
      flex: 1;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.modal-content {
  border: none;
  font-size: 13px;
  color: #999999;
  div {
    margin-bottom: 10px;
    text-indent: 15px;
    letter-spacing: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter/component/live_tip.vue